import { sample } from '@sama/micro-dash';
import { Answer } from '../../team-apis/otterdam/answers/answer';
import { RadioOutput } from '../../team-apis/otterdam/outputs/radio-output';
import { OutputHelper } from './output-helper';

export class RadioOutputHelper extends OutputHelper<RadioOutput> {
  override supportsDefaultAnswer = true;

  override getLabelFor(answer: Answer | undefined, output: RadioOutput) {
    return this.getMatchingAnswerOptionLabel(answer, output);
  }

  override makeRandomAnswer(output: RadioOutput) {
    return sample(output.answer_options).name;
  }
}
